
import { mapState } from 'vuex'
import moment from 'moment'
import opco from '~/assets/src/opco.json'

export default {
  props: ['gcid', 'redir'],
  computed: {
    ...mapState([
      'location',
      'menu',
      'order',
      'user',
      'handoff',
      'submitting',
      'client',
      'createAccount',
      'channel'
    ])
  },
  data() {
    return {
      checkoutFrame: null,
      expiration: null,
      zipcode: null,
      savecard: false,
      errors: [],
      hideSaveCard: false,
      payment: {},
      showPaymentForm: false,
    }
  },
  async mounted() {
    try {
      window.checkoutFrame.on('ready', null)
      window.checkoutFrame.on('validate', null)
      window.checkoutFrame.on('error', null)
      window.checkoutFrame.on('success', null)
    } catch(err) {
      // ignore
    }
    window.checkoutFrame = null
    setTimeout(this.checkForm, 500)

    if (!this.user || this.user.payments.length == 0) {
      this.showPaymentForm = true
    }
  },
  methods: {
    checkForm() {
      if (document.getElementById('card-number')) {
        this.setForm()
      } else {

        setTimeout(this.checkForm, 500)
      }
    },
    setForm() {
      const styles =
        'outline: 0px; max-width: 100%; width: 100%; display: block; height: 39px; padding: 0px 20px 0 20px; font-size: 16px; border-width: 0px; font-weight: 500; font-family: monospace;';

      // Initialize the Olo.CheckoutFrame
      window.checkoutFrame = new Olo.CheckoutFrame({
        cardElement: 'card-number-placeholder',
        cvvElement: 'cvv-placeholder'
      });

      // Attach event listeners
      window.checkoutFrame.on('ready', this.onReady);
      window.checkoutFrame.on('validate', this.onValidate);
      window.checkoutFrame.on('error', this.onError);
      window.checkoutFrame.on('success', this.onSuccess);

      const brandAccessId = window.location.href.includes('catering') ? 'OS7FeSqyIYIthGSPKmf61zSMs5KFi3wZ' : process.env.OLO_BRAND_ACCESS;

      console.log(process.env.GW_ENV, 'process.env.GW_ENV Payment');
      console.log(brandAccessId, ' Payment');


      window.checkoutFrame.initialize({
        brandAccessId: brandAccessId, 
        styles: {
          cardNumber: styles,
          cvv: styles
        }
      });
    },
    onReady(result) {

    },
    onValidate(result) {
      this.$store.commit('setLoading', false)
      this.errors = ['cardnumber', 'cvv']
      this.$store.commit('setErrors', ['Invalid payment details'])
      this.$store.commit('setSubmitting', false)
    },
    async onError(result) {
      let error = null
      if(result.description) {
        error = result.description
      } else if(Array.isArray(result) && result[0].description == ';') {
        error = 'There was a problem with your payment. Please check your card details and try again.'
      } else {
        error = result[0].description || 'There was a problem with your payment. Please check your card details and try again.'
      }
      await this.$api.trackPaymentFailure(this.order.id, error, this.payment)
      this.$store.commit('setSubmitting', false)
      this.$store.commit('setLoading', false)
      this.$store.commit('setErrors', [error])
    },
    async onSuccess(result) {
      const products = JSON.parse(JSON.stringify(this.order))
      await this.$api.trackOrder(this.order.id, result.id, products.products)
      try {
        if (products && this.location) {
          const purchases = []
          products.products.map((p) => {
            purchases.push({
              name: p.name,
              price: p.cost.total,
              quantity: p.quantity,
              sku: p.product_id
            })
          })
          const transactionDetails = {
            ecommerce: {
              purchase: {
                actionField: {
                  id: products.id,
                  revenue: products.totals.total,
                  tax: products.totals.tax
                },
                storeNumber: this.location.id,
                zipCode: this.location.zip,
                products: purchases
              }
            }
          }
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push(transactionDetails)
        }
      } catch(err) {
        // do nothing
      }
      this.$store.commit('setOrder', null)
      this.$store.commit('setSubmitting', false)
      if(this.redir) {
        if(this.client == 'ios') {
          let postMessage = window.parent.postMessage
          if(window.ReactNativeWebView) {
            postMessage = window.ReactNativeWebView.postMessage
          }
          postMessage(result.id)
        } else if(this.client === 'android') {
          window.webView.postMessage(result.id)
        }
        window.location = `${this.redir}?id=${result.id}`
      } else {
        if (this.savecard && this.user) {
          await this.$api.getPayments()
        }
        this.$router.push(`/order/confirm?id=${result.id}`)
      }
    },
    async submitOrder() {
      if (!this.showPaymentForm) {
        return // prevent submission if stored cards are shown
      }
      const errors = []
      const exp = moment(this.expiration, 'MM/YYYY')
      const test = moment(this.expiration, 'MM/YYYY').add(1, 'month')
      const now = moment()
      
      if (this.channel !== 'catering') {
        if (!this.expiration || test <= now) {
          errors.push('expiration')
        }
        if (!this.zipcode || !this.zipcode.match(/\d{5}/)) {
          errors.push('zipcode')
        }
      }

      this.errors = errors
      if (errors.length > 0) {
        this.$store.commit('setSubmitting', false)
        this.$store.commit('setErrors', ['Please check your payment details'])
      } else {
        const token = await this.$api.getBasketToken()
        this.payment = {
          id: this.order.id,
          accessToken: token.accesstoken,
          firstName: this.user ? this.user.first_name : this.handoff.first_name,
          lastName: this.user ? this.user.last_name : this.handoff.last_name,
          emailAddress: this.user ? this.user.email : this.handoff.email,
          contactNumber: this.handoff && this.handoff.phone ? this.handoff.phone.replace(/^\+?1/, '') : null,
          usertype: this.user ? 'user' : 'guest',
          createoloaccount: this.createAccount ? true : false,
          billingaccounts: []
        }

        this.payment.billingaccounts.push({
          billingmethod: 'creditcard',
          expiryyear: exp.format('YYYY'),
          expirymonth: exp.format('MM'),
          zip: this.zipcode,
          saveonfile: this.savecard,
          tipportion: this.order.totals.tip,
          amount: this.order.totals.total
        })
        
        window.checkoutFrame.submit(this.payment)
      }
    },
  },
  watch: {
    submitting(e) {
      if (e) {
        this.submitOrder()
      }
    }
  }
}
